import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import DiscountTagLoader from 'client/components/DiscountTagLoader'
import IconLightning from 'client/icons/Lightning'

import { DiscountTagBase, PrimeDiscountText } from './styles'

interface Props {
  isLoading?: boolean
  discount: number
  prime?: boolean
  className?: string
}

const DiscountTag = ({
  isLoading = false,
  discount,
  prime = false,
  className = 'discount-tag',
}: Props) => {
  const primeDiscount = useMemo(
    () => (
      <PrimeDiscountText>
        <IconLightning size={20} />
        <FormattedMessage id="global.prime" />
        <FormattedMessage id="discount.today" values={{ discount: `: -${discount}%` }} />
      </PrimeDiscountText>
    ),
    [discount]
  )

  const discountCopy = useMemo(() => {
    return (
      <>
        {`-${discount}% `}
        <FormattedMessage id="global.today" />
      </>
    )
  }, [discount])

  if (isLoading) {
    return <DiscountTagLoader />
  }

  if (!discount) {
    return null
  }

  return (
    <DiscountTagBase className={className} prime={prime}>
      {prime ? primeDiscount : discountCopy}
    </DiscountTagBase>
  )
}

export default DiscountTag
